import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { Link } from "react-router-dom";
import { collection, getDocs } from 'firebase/firestore';
import { query, orderBy, startAt } from "firebase/firestore";

import moment from 'moment';

const DocumentList = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    const fetchDocuments = async () => {
      const querySnapshot = await getDocs(collection(db, "deliveryOrders"));
      const fetchedDocuments = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setDocuments(fetchedDocuments);
    };

    fetchDocuments();
  }, []);

  const StatusDot = (props) => {
    if (props.status === 'new') {
      return <span className="dot-green"></span>;
    } else if (props.status === 'draft') {
      return <span className="dot-red"></span>;
    }

    return <span className="dot-gray"></span>;
  };

  const formatDate = (date) => {
    return moment(new Date(date)).format('DD/MM/YYYY')
  }

  const formatTime = (date) => {
    return moment(new Date(date)).format('dddd [at] h:mm a')
  }

  const renderItems = (items) => {
    const categories = {}
    items.forEach(item => {
      if (item.category in categories) {
        categories[item.category] += item.quantity;
      } else {
        categories[item.category] = item.quantity;
      }
    });

    return <>
      {
        Object.entries(categories).map(([category, quantity]) => {
          return <div>- {category} [<span className="text-secondary">{quantity}&times;</span>]</div>
        })
      }
    </>
  }

  return (
    <div>
      <h2>Document List</h2>
      <table className="table table-bordered" id="dataTable">
        <thead className="table-light">
          <tr>
            <th></th>
            <th className="align-top">Reference Number</th>
            <th className="align-top">Site &amp; PIC</th>
            <th className="align-top">Items</th>
            <th className="align-top">Reason</th>
            <th className="align-top">Status</th>
            <th className="align-top">Created At</th>
            <th></th>
            <th className="align-top">Actions</th>
          </tr>
        </thead>
        <tbody>
          {documents.map(doc => (
            <tr key={doc.id}>
              <td className="fit-content">
                <StatusDot status={doc.status} />
              </td>
              <td>
                {doc.status === 'draft' ? <em className="text-secondary">Draft document</em> : !doc.referenceNumber ? <em className="text-secondary">Not set</em> : doc.referenceNumber}
                {doc.remark ? <small className="text-warning d-block">Remark: {doc.remark}</small> : ''}
              </td>
              <td>
                {doc.site}<br />
                <small className="text-secondary">{doc.personInCharge}</small>
              </td>
              <td>
                {renderItems(doc.items)}
              </td>
              <td>
                {doc.reason}
                {doc.reasonOther ? <small className="text-secondary d-block">{doc.reasonOther}</small> : ''}
              </td>
              <td className="fit-content">{doc.status}</td>
              <td className="fit-content">
                <div>{formatDate(doc.createdAt.toDate())}</div>
                <small className="text-secondary d-block">{formatTime(doc.createdAt.toDate())}</small>
                <small className="text-secondary d-block">by {doc.createdBy}</small>
              </td>
              <td className="fit-content">
                {doc.status === 'draft' ? <button className="btn btn-warning btn-sm" onClick={() => alert(doc.id)}>Publish</button> : ''}
                {doc.status === 'new' ? <button className="btn btn-success btn-sm" onClick={() => alert(doc.id)}>Recieve</button> : ''}
              </td>
              <td className="fit-content">
                <Link to={`/document/print/${doc.id}`}
                  className="btn btn-sm btn-secondary me-1">Print</Link>
                <Link to={`/document/print/${doc.id}`}
                  className="btn btn-sm btn-secondary me-1">Edit</Link>
                <button onClick={() => alert(doc.id)}
                  className="btn btn-sm btn-danger">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <pre>
        { JSON.stringify(documents, null, 2) }
      </pre>
    </div>
  );
};

export default DocumentList;
